<template>
  <mdb-container fluid>
    <DataTableAG
      :columns="columns"
      width="900px"
      height="600px"
      :getcontentpath="getcontentpath"
      jsonobject="surrogateimportstats"
      :rowHeight="120"
    />
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer } from "mdbvue";

export default {
  name: "SurrogateImportStats",
  components: {
    DataTableAG,
    mdbContainer,
  },
  props: {},
  data: () => ({
    getcontentpath: "/1.0/front/surrogateimport/stats",
    columns: [
      {
        field: "name",
        headerName: "Ryhmä",
        width: 300,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "abbr",
        headerName: "Lyhenne",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "total",
        headerName: "Kaikki",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "used",
        headerName: "Käytetyt",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "remaining",
        headerName: "Jäljellä olevia",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  methods: {

  },
  mounted() {},
};
</script>